import { render, staticRenderFns } from "./heim-user-card.vue?vue&type=template&id=24725b74&scoped=true&"
import script from "./heim-user-card.vue?vue&type=script&lang=js&"
export * from "./heim-user-card.vue?vue&type=script&lang=js&"
import style0 from "./heim-user-card.vue?vue&type=style&index=0&id=24725b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24725b74",
  null
  
)

component.options.__file = "heim-user-card.vue"
export default component.exports